import { BaseEntity } from "../../../models/concrete/BaseEntity.mjs";
export class Filter extends BaseEntity {
  collapse;
  name;
  variants;
  available;
  slug;
  unit;
  help;
  min;
  max;
  urlSort;
  default;
  filterName;
  filterType;
  filterTemplate;
  nameForFilter;
  nameForProduct;
  nameForProductCard;
  hideNameOnProduct;
  hideNameOnProductCard;
  counts;
  constructor(data) {
    super(data);
    this.id = data.id;
    this.collapse = data.collapse;
    this.variants = data.variants.map((v) => ({
      label: v.label,
      slug: v.slug,
      value: v.value,
      imageId: v.image_id,
      isFavorite: v.is_favorite,
      depth: v.depth,
      parentId: v.parent_id,
      description: v.description
    }));
    this.name = data.name;
    this.slug = data.slug;
    this.min = data.min;
    this.max = data.max;
    this.unit = data.unit;
    this.help = data.help;
    this.urlSort = data.url_sort;
    this.available = data.available;
    this.default = data.default;
    this.filterName = data.filterName;
    this.filterType = data.type;
    this.filterTemplate = data.filter_template;
    this.nameForFilter = data.name_for_filter;
    this.nameForProduct = data.name_for_product;
    this.nameForProductCard = data.name_for_product_card;
    this.hideNameOnProduct = data.hide_name_on_product;
    this.hideNameOnProductCard = data.hide_name_on_product_card;
    this.counts = data.counts;
  }
  toJSON() {
    return { ...this };
  }
}
